import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setVizLoading } from '../../../../store/visualizerSlice';
import ProductGroupStep from '../ProductGroupStep/ProductGroupStep';

export default function CabinetHandles({
    surfaceName = 'Cabinet Handles',
    stepIndex,
    room = '',
    onViewAllApplied,
    onNext,
    onPrevious
}) {
    const dispatch = useDispatch();

    const handleSelect = useCallback((product) => {
        const chamViz = document.getElementById('chamViz');
        if (!chamViz || !product.id) return;

        dispatch(setVizLoading(true));

        chamViz.applyByFilter(
            product.id,
            '',
            function(newSel) {
                if (this.name === 'Cabinet Handles') return newSel;
                return this.sel;
            },
            true
        );
    }, [dispatch]);

    return (
        <ProductGroupStep
            title="Cabinet Handles"
            stepName="CabinetHandles"
            seriesId="9791"
            surfaceName={surfaceName}
            stepIndex={stepIndex}
            room={room}
            onViewAllApplied={onViewAllApplied}
            onNext={onNext}
            onPrevious={onPrevious}
            onProductSelect={handleSelect}
            noFilter
        />
    );
}

CabinetHandles.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
